import RegisterContent from './RegisterContent'

export default RegisterContent
